'use strict';

function getKeys(obj) {
  return Object.keys(obj);
}

module.exports = getKeys;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/getKeys.js
// module id = 133
// module chunks = 1